import React from 'react';
import './tranding.css';
import { Link } from "react-router-dom";
import Domestic from './Image/International.avif'
const Footer = () => {
  return (
    <div className="mainHome-container">
    
    <section className="product-categories" style={{height:"auto", paddingBottom:"50px"}}>
      <h2>Our Trading Operations</h2>
      <p>Learn about our comprehensive domestic and international trading services</p>
      <div className="tranding-mid-container">
        <div className="tranding-mid-container-contact-left">
            <div className="tranding-pics">
                <img src={Domestic} alt="" className='tranding-left-pics' />
            </div>

        </div>

        <div className="tranding-mid-container-contact-right">
            <div className='tranding-tittle'>
            International Trading
            </div>
            <div className='tranding-mid-details'>
            Our international trading division facilitates global commerce, connecting suppliers and buyers across borders with efficient logistics and compliance management.
            </div>
            <div className="tranding-mid-details-content-box">
                <div className="tranding-mid-details-content-box-title">Global Reach</div>
                <div className="tranding-mid-details-content-box-details">Trading operations spanning across Asia, Europe, Middle East, Africa, and the Americas.</div>
            </div>
            <div className="tranding-mid-details-content-box">
                <div className="tranding-mid-details-content-box-title">Customs & Compliance</div>
                <div className="tranding-mid-details-content-box-details">Expert handling of documentation, customs clearance, and international trade compliance.</div>
            </div>
            <div className="tranding-mid-details-content-box">
                <div className="tranding-mid-details-content-box-title">Shipping & Logistics</div>
                <div className="tranding-mid-details-content-box-details">Comprehensive shipping solutions including sea, air, and land transport for all product categories.</div>
            </div>
            
          </div>
        </div>
        <ul style={{display:'flex',listStyle:'none',gap:'20px',justifyContent:'center'}}>
                <li style={{fontWeight:'semibold'}}>Looking for Domestic Trading?</li>
                <li  ><Link to="/domestic-trading" style={{color:"orange"}}>View Domestic Trading Services</Link></li>
              </ul>

      
    </section>
    
    </div>
  );
};

export default Footer;

